// @flow

//
// React
//
import React from 'react';

//
// Material UI
//
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';

//
// Formatter
//
import {
    fmtDate,
    fmtTime,
    fmtMoney,
    fmtDocumentNumber
} from '../../../../../lib/trix-web-data-commons';

//
// Extender
//
import withHalFormsAction from '../../../../../lib/trix-web-hal-forms/extender/withHalFormsAction';

//
// Component
//
const OpenRetailSaleTableToolbarButtons = (props: any): any => {
    return (
        <Grid item>
            <Tooltip title='Нова продажба'>
                <IconButton
                    onClick={() => {
                        let action = null;
                        for (let n in props.__halFormsTemplate.actions) {
                            if (props.__halFormsTemplate.actions[n].name === 'newSale') {
                                action = props.__halFormsTemplate.actions[n];
                                break;
                            }
                        }

                        if (action) {
                            props.__halFormsActionExtender.executeHalFormsAction(
                                action, props.data, props.container, {});
                        }
                    }}
                    size='large'
                >
                    <InsertDriveFileOutlinedIcon fontSize='small' />
                </IconButton>
            </Tooltip>
        </Grid>
    );
}

export default withHalFormsAction ({}) (OpenRetailSaleTableToolbarButtons);
